import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ec3f64a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import AppHeader from '@/components/Header.vue'
import { useRouter } from 'vue-router'
import { getEntryInfo } from '@/utils'
import { IframeWrapWindowtHistoryKey } from '@/config/constant'
import { ref, getCurrentInstance, onMounted, nextTick } from 'vue'
import { useWatchMessageHandle } from '@/compositions/useCustomWindowApi'
import { useActiveHandle } from '@/compositions/insurance/useActiveHandle'
import { usePlatformInfo } from '@/compositions/common'

export default /*#__PURE__*/_defineComponent({
  __name: 'Iframe-wrap',
  setup(__props) {

const title = ref('')
const url = ref('')
const showIframe = ref(true)
const $router = useRouter()
const entryData = getEntryInfo()
const isFromActive = entryData.type === 'active'
const activeKey = entryData.activeKey
const sn = entryData.sn
const client = entryData.client
const { proxy } = getCurrentInstance()
const isPinganType = (proxy.$route.query.type as string) === 'pingan'
const startHistoryLength = window.history.length
const { isLandscape } = usePlatformInfo()
const { activeHandle } = useActiveHandle(sn, client, activeKey)
let $el: HTMLIFrameElement | null = null

function watchMessageHandle(data: string) {
  console.log('data', data)
  try {
    const obj = JSON.parse(data)
    if (obj.title) {
      title.value = obj.title
    }
  } catch (error) {
    console.log('error', error)
  }
}
useWatchMessageHandle(watchMessageHandle)
function pinganServiceBackHandle() {
  if (isFromActive) {
    // 直接尝试激活后返回激活页面即可
    activeHandle()
    return
  }
  try {
    // 嵌套平安收银台的时候，当支付完成或者取消支付后会跳转到指定页面，在这些页面点击后退将后退到调用平安收银台之前
    let childOrigin = $el.contentWindow.location.origin
    if (childOrigin === window.location.origin) {
      $router.go(-1 * (window.history.length - startHistoryLength + 1))
    }
    return
  } catch (error) {
    $router.go(-1)
  }
}
function leftClickHandle() {
  if (!isPinganType) {
    // 常规情况下使用浏览器的默认后退
    $router.go(-1)
    return
  }
  pinganServiceBackHandle()
}
onMounted(() => {
  title.value = proxy.$route.query.title as string
  url.value = decodeURIComponent(proxy.$route.query.url as string)
  $el = document.getElementById('my-iframe') as HTMLIFrameElement
  //console.log('el.contentWindow.document.title', el.contentWindow.document.title)
  sessionStorage.setItem(IframeWrapWindowtHistoryKey, String(startHistoryLength))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: title.value,
      onLeftClick: leftClickHandle,
      isReturnLeftEvent: ""
    }, null, 8, ["title"]),
    (showIframe.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["protoc-page", _unref(isLandscape) ? 'page-landscape-wrap' : ''])
        }, [
          _createElementVNode("iframe", {
            src: url.value,
            class: "protoc-ifram",
            id: "my-iframe"
          }, null, 8, _hoisted_1)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})